module.exports = __webpack_public_path__ + "static/media/alligator-gar.483fb24b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/fish/alligator-gar.png
// module id = 291
// module chunks = 0